import { render, staticRenderFns } from "./AnagraficaPage.vue?vue&type=template&id=0cd14cdd&"
import script from "./AnagraficaPage.vue?vue&type=script&lang=js&"
export * from "./AnagraficaPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports